"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var user_context_provider_1 = require("./user_context_provider");
var user_context_helpers_1 = require("../user_context_helpers");
function ExperimentSwitch(props) {
    var Component = user_context_helpers_1.isExperimentEnabled(props.user, props.experimentName)
        ? props.experimentComponent
        : props.defaultComponent;
    return Component;
}
exports.ExperimentSwitch = ExperimentSwitch;
exports.default = user_context_provider_1.withUserContext(ExperimentSwitch);
//# sourceMappingURL=experiment_switch.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/experiment_switch.js
// module id = TQYT
// module chunks = 20 21